import { Div, Collection, TableBuilder, Span } from "@tblabs/truffle";
import { IoState } from "../../Services/IoState";


export class IoStateViewer extends Div
{
    private data = new Collection<{ name: string; value: string; }>();

    constructor()
    {
        super();

        this.Append(
            new TableBuilder(this.data).WidthAuto()
                .AddColumn("Name", entry => new Span(entry.name))
                .AddColumn("Value", entry => new Span(entry.value))
                .Build()
        );
    }

    public Refresh(ioState: IoState): this
    {
        this.data.Clear();

        for (const [inputName, inputValue] of Object.entries(ioState.InputsState))
        {
            let value = ioState.InputsMalfunction.includes(inputName) ? "MALFUNCTION" : inputValue.toString();

            if (value == "-1")
                value = "no value yet";

            this.data.Add({ name: inputName, value: value });
        }
        for (const [outputName, outputValue] of Object.entries(ioState.OutputsState))
        {
            this.data.Add({ name: outputName, value: outputValue.toString() });
        }

        return this;
    }
}
